/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum TrebleProduct {
  TASS = "TASS",
  TSDK = "TSDK",
}

/**
 * Defines SDK execution tiers, determining resource allocation constraints.
 * Higher tiers provide increased GPU and CPU concurrency for compute-intensive workloads.
 */
export enum SdkTier {
  A = "A",
  B = "B",
  C = "C",
  D = "D",
  E = "E",
  F = "F",
}

export enum Role {
  Default = "Default",
  Admin = "Admin",
  Superuser = "Superuser",
  DataAccess = "DataAccess",
  Test = "Test",
  Viewer = "Viewer",
}

export enum PaymentFrequency {
  Monthly = "Monthly",
  Yearly = "Yearly",
  Quarterly = "Quarterly",
  Biannually = "Biannually",
  SixWeeks = "SixWeeks",
}

export enum PackageType {
  Trial = "Trial",
  SignUp = "SignUp",
  Purchase = "Purchase",
  Free = "Free",
  Compensation = "Compensation",
}

export enum ChargebeeSubscriptionType {
  Flexible = "Flexible",
  Unlimited = "Unlimited",
  SinglePremium = "SinglePremium",
  SingleStandard = "SingleStandard",
  TeamPremium = "TeamPremium",
  TeamStandard = "TeamStandard",
  Enterprise = "Enterprise",
  SDK = "SDK",
}

export enum BillingType {
  Trial = "Trial",
  EarlyBird = "EarlyBird",
  Unlimited = "Unlimited",
  PrepaidOnly = "PrepaidOnly",
  OnDemandOnly = "OnDemandOnly",
  Free = "Free",
  SinglePremium = "SinglePremium",
  SingleStandard = "SingleStandard",
  TeamPremium = "TeamPremium",
  TeamStandard = "TeamStandard",
  Enterprise = "Enterprise",
}

export interface AddTokenPackageRequest {
  /** @format uuid */
  organizationId?: string;
  /** @format double */
  tokens?: number;
  /** @format date-time */
  expiresAt?: string | null;
  packageType?: PackageType | null;
}

export interface ApiUserDto {
  /** @format uuid */
  clientId?: string;
  oauthUsername?: string | null;
  auth0Id?: string | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format uuid */
  contactId?: string | null;
  /** @format uuid */
  organizationId?: string | null;
  roles?: string[] | null;
  enabled?: boolean;
  isM2M?: boolean;
  /** @format uuid */
  userId?: string | null;
  user?: UserDto | null;
  contact?: ContactDto | null;
  organization?: OrganizationDto | null;
}

export interface BillingAddress {
  country?: string | null;
  company?: string | null;
  line1?: string | null;
  line2?: string | null;
  city?: string | null;
  zip?: string | null;
}

export interface ChargebeeInvoice {
  id?: string | null;
  recurring?: boolean;
  customer_id?: string | null;
  subscription_id?: string | null;
  status?: string | null;
  /** @format int64 */
  date?: number | null;
  vat_number?: string | null;
  currency_code?: string | null;
  /** @format int32 */
  tax?: number;
  /** @format int32 */
  total?: number;
  line_items?: WebhooksLineItem[] | null;
  billing_address?: BillingAddress | null;
  /** @format int32 */
  uniconta_order_number?: number | null;
}

export interface ChargebeeSubscription {
  id?: string | null;
  customer_id?: string | null;
  status?: string | null;
  /** @format int32 */
  cancelled_at?: number | null;
  /** @format int32 */
  current_term_end?: number | null;
  /** @format int32 */
  next_billing_at?: number | null;
  subscription_items?: SubscriptionItem[] | null;
}

export interface ChargebeeSubscriptionDto {
  /** @format date-time */
  cancelledAt?: string | null;
  /** @format date-time */
  nextBillingAt?: string | null;
  /** @format date-time */
  currentTermEnd?: string | null;
  status?: string | null;
}

/** Used when requesting a Chargebee hosted page to update a subscription */
export interface ChargebeeSubscriptionRequest {
  product?: TrebleProduct;
  /** Subscription type in Chargebee. Possible values: Flexible, Unlimited */
  subscriptionType?: ChargebeeSubscriptionType;
  /** Payment frequency in Chargebee. Possible values: Montly, Yearly */
  paymentFrequency?: PaymentFrequency;
  /**
   * Total number of seats included in the subscription
   * @format int32
   */
  includedSeats?: number;
  /**
   * The trial end date for the subscription, if applicable.
   * @format date-time
   */
  trialEnd?: string | null;
  /** Unique identifier for the Impact click that initiated the subscription */
  impactClickId?: string | null;
  /** Reference id to map partners in Impact to deals they have initiated */
  impactPartnerId?: string | null;
}

export interface CommitTokenUsageRequest {
  /** @format uuid */
  reservationId?: string;
  /** @format double */
  totalTokens?: number;
  /** @format double */
  billableTokens?: number;
}

export interface CommitTokenUsageRequestBatch {
  commitTokenUsages: CommitTokenUsageRequest[];
}

export interface CommitTokenUsageResponse {
  /** @format uuid */
  reservationId?: string;
  /** @format uuid */
  productTraceId?: string;
  productTraceType?: string | null;
  /** @format double */
  tokensFromPackages?: number;
}

export interface ContactDto {
  /** @format uuid */
  id?: string;
  contactDescription?: string | null;
  email?: string | null;
  addressJson?: string | null;
}

export interface CreateProductDto {
  productKey?: TrebleProduct;
  billingType?: BillingType;
  /** Frequency of payments in Chargebee (monthly/yearly) */
  paymentFrequency?: PaymentFrequency | null;
  /** @format int32 */
  concurrency?: number;
  /** @format int32 */
  maxSeats?: number;
  /** @format date-time */
  expiresAt?: string | null;
  /** @format int32 */
  sdkMaxCpuConcurrency?: number | null;
  /** @format int32 */
  sdkMaxGpuConcurrency?: number | null;
  /** @format int32 */
  sdkMaxGpuCountPerTask?: number | null;
  /** @format int32 */
  rateLimit?: number | null;
  sdkTier?: SdkTier | null;
  chargebeeSubscriptionId?: string | null;
  /** @format int32 */
  impactPartnerId?: number | null;
  impactClickId?: string | null;
}

export interface CreateProductRequest {
  /** @format uuid */
  organizationId?: string | null;
  product?: CreateProductDto | null;
  tokenPackage?: AddTokenPackageRequest | null;
}

export interface CreateSubscriptionRequest {
  /** @format uuid */
  organizationId?: string;
  products?: CreateProductDto[] | null;
  /** @format uuid */
  userId?: string | null;
  chargebeeCustomerId?: string | null;
  skipChargebee?: boolean;
}

export interface CreateUserProductAccessRequest {
  /** @format uuid */
  userId?: string;
  product?: TrebleProduct;
}

export interface GetOrganizationProductAccessesRequest {
  /** @format uuid */
  organizationId?: string;
  product?: TrebleProduct | null;
}

export interface GetOrganizationProductAccessesResponse {
  productAccessesByProduct?: {
    TASS?: ProductAccessDto[];
    TSDK?: ProductAccessDto[];
  } | null;
}

export interface GetOrganizationUserProductAccessesResponse {
  userProductAccesses?: UserProductAccessDto[] | null;
}

export interface GetProductAccessRequest {
  /** @format uuid */
  organizationId?: string;
  productKey?: TrebleProduct;
}

export interface GetProductAccessesResponse {
  productAccesses?: ProductAccessDto[] | null;
}

export interface GetSubscriptionRequest {
  /** @format uuid */
  organizationId?: string;
  product?: TrebleProduct | null;
}

export interface GetSubscriptionResponse {
  /** @format uuid */
  subscriptionId?: string;
  products?: ProductDto[] | null;
  chargebeeSubscription?: ChargebeeSubscriptionDto[] | null;
  chargebeeCustomerId?: string | null;
}

export interface GetTokenStatusRequest {
  /** @format uuid */
  organizationId?: string;
}

export interface GetTokenStatusResponse {
  /** @format double */
  reservableTokens?: number;
  /** @format double */
  reservedTokens?: number;
  /** @format double */
  tokensLeftInPackages?: number;
}

export interface GetTokenUsageReportRequest {
  /** @format uuid */
  organizationId: string;
  /** @format date-time */
  from: string;
  /** @format date-time */
  to: string;
}

export interface GetUserProductAccessRequest {
  /** @format uuid */
  userId?: string;
  product?: TrebleProduct;
}

export interface GetUserProductAccessResponse {
  productAccess?: ProductAccessDto | null;
}

export interface HostedPage {
  /** @format int32 */
  created_at?: number | null;
  embed?: boolean;
  /** @format int32 */
  expires_at?: number | null;
  id?: string | null;
  object?: string | null;
  /** @format int64 */
  resource_version?: number | null;
  state?: string | null;
  type?: string | null;
  /** @format int32 */
  updated_at?: number | null;
  url?: string | null;
}

export interface HostedPageResponse {
  hosted_page?: HostedPage | null;
}

export interface LinkedCustomer {
  customer_id?: string | null;
  has_active_subscription?: boolean | null;
  has_billing_address?: boolean | null;
  has_payment_method?: boolean | null;
  object?: string | null;
}

export interface OrganizationDto {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  organizationId?: string;
  name?: string | null;
  useSso?: boolean;
  /** Indicates whether this organization relies on private pollers for GPU based tasks. */
  markGpuTasksAsPrivate?: boolean;
  /** Indicates whether this organization relies on private pollers for CPU based tasks. */
  markCpuTasksAsPrivate?: boolean;
}

export interface PortalSession {
  access_url?: string | null;
  /** @format int32 */
  created_at?: number | null;
  customer_id?: string | null;
  /** @format int32 */
  expires_at?: number | null;
  id?: string | null;
  object?: string | null;
  redirect_url?: string | null;
  status?: string | null;
  token?: string | null;
  linked_customers?: LinkedCustomer[] | null;
}

export interface PortalSessionResponse {
  portal_session?: PortalSession | null;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

/** Used to get product information along with product access information. */
export interface ProductAccessDetailedDto {
  /** @format uuid */
  productAccessId?: string;
  isEnabled?: boolean;
  /** @format date-time */
  expiresAt?: string;
  user?: UserDto | null;
  product?: ProductDto | null;
}

export interface ProductAccessDto {
  /** @format uuid */
  productAccessId?: string;
  shouldRenew?: boolean;
  isEnabled?: boolean;
  /** @format date-time */
  expiresAt?: string;
  billingType?: BillingType | null;
  user?: UserDto | null;
}

export interface ProductAccessUserDto {
  /** @format uuid */
  productAccessId?: string;
  shouldRenew?: boolean;
  isEnabled?: boolean;
  /** @format date-time */
  expiresAt?: string;
  billingType?: BillingType | null;
  productKey?: string | null;
}

export interface ProductDto {
  productKey?: TrebleProduct;
  billingType?: BillingType;
  /** Frequency of payments in Chargebee (monthly/yearly) */
  paymentFrequency?: PaymentFrequency | null;
  /** @format int32 */
  concurrency?: number;
  /** @format int32 */
  maxSeats?: number;
  /** @format date-time */
  expiresAt?: string | null;
  /** @format int32 */
  sdkMaxCpuConcurrency?: number | null;
  /** @format int32 */
  sdkMaxGpuConcurrency?: number | null;
  /** @format int32 */
  sdkMaxGpuCountPerTask?: number | null;
  /** @format int32 */
  rateLimit?: number | null;
  sdkTier?: SdkTier | null;
  chargebeeSubscriptionId?: string | null;
  /** @format int32 */
  impactPartnerId?: number | null;
  impactClickId?: string | null;
  /** @format uuid */
  id?: string;
  /** @format int32 */
  activeSeats?: number | null;
  /** @format int32 */
  viewerSeats?: number | null;
}

/**
 * Represents a request to reserve a specified number of tokens for a product.
 * Includes properties for the product ID, organization ID, and user ID involved in the request.
 * The 'Tokens' property specifies the amount of tokens to be reserved.
 * 'ProductTraceId' is a unique identifier used for traceability, for TASS this should be SimulationRunId.
 * ProductTraceType is the type of the trace id, for TASS this should be "SimulationRun".
 * The 'CanReservePartialAmount' flag indicates whether partial reservation of tokens is permissible
 * in case the total requested amount is not available.
 */
export interface ReserveTokensRequest {
  product?: TrebleProduct;
  /** @format uuid */
  organizationId?: string;
  /** @format uuid */
  userId?: string;
  /** @format double */
  tokens?: number;
  /** @format uuid */
  productTraceId?: string;
  productTraceType?: string | null;
  canReservePartialAmount?: boolean;
}

export interface ReserveTokensRequestBatch {
  reserveTokens: ReserveTokensRequest[];
  canReservePartialAmount?: boolean;
}

export interface ReserveTokensResponse {
  isSuccess?: boolean;
  /** @format double */
  tokensReserved?: number | null;
  /** @format uuid */
  reservationId?: string | null;
  /** @format date-time */
  expiresAt?: string | null;
  /** @format uuid */
  productTraceId?: string | null;
  productTraceType?: string | null;
}

export interface SimulationUsageDto {
  /** @format uuid */
  simulationId?: string;
  simulationName?: string | null;
  /** @format double */
  usage?: number;
  /** @format int32 */
  runtime?: number | null;
  /** @format uuid */
  userId?: string;
  email?: string | null;
  /** @format int32 */
  maxGPUCount?: number | null;
  /** @format date-time */
  completedAt?: string | null;
}

export interface SimulationUsageInfoDto {
  /** @format uuid */
  projectId?: string;
  projectName?: string | null;
  /** @format double */
  totalUsage?: number;
  simulationUsages?: SimulationUsageDto[] | null;
}

export interface SubscriptionItem {
  /** @minLength 1 */
  item_price_id: string;
  /** @format int32 */
  quantity?: number | null;
  /** @minLength 1 */
  item_type: string;
}

export interface TokensRequest {
  item_prices?: SubscriptionItem[] | null;
}

export interface UpdateProductRequest {
  /** @format uuid */
  id?: string;
  billingType?: BillingType | null;
  /** @format int32 */
  concurrency?: number | null;
  /** @format int32 */
  maxSeats?: number | null;
  /** @format date-time */
  expiresAt?: string | null;
  /** @format int32 */
  rateLimit?: number | null;
  /** @format int32 */
  sdkMaxCpuConcurrency?: number | null;
  /** @format int32 */
  sdkMaxGpuConcurrency?: number | null;
  /** @format int32 */
  sdkMaxGpuCountPerTask?: number | null;
  sdkTier?: SdkTier | null;
  chargebeeSubscriptionId?: string | null;
  addTokenPackageRequest?: AddTokenPackageRequest | null;
}

export interface UserDto {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  organizationId?: string | null;
  auth0Id?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  trialExpiresAt?: string | null;
  featureFlags?: string[] | null;
  roles?: Role[] | null;
  isDeleted?: boolean;
  /**
   * The SDK client id of the user if user has access to the SDK
   * @format uuid
   */
  sdkClientId?: string | null;
  /**
   * SDK oath username (auth0 email) of the user if user has access to the SDK. For SSO users this is their email,
   * for other users this is tsdk+{sdkClientId}@treble.tech
   */
  sdkOauthUsername?: string | null;
  /**
   * Since user can have a SdkClientId and/or SdkOauthUsername but at the same time not have ProductAccess to the SDK
   * we need this boolean flag that states if the user truly has access to the SDK or not.
   */
  hasSDKAccess?: boolean;
  /**
   * The date and time when the user accepted the terms and conditions.
   * @format date-time
   */
  termsAndConditionsAcceptedAt?: string | null;
}

export interface UserProductAccessDto {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  organizationId?: string | null;
  auth0Id?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  trialExpiresAt?: string | null;
  featureFlags?: string[] | null;
  roles?: Role[] | null;
  isDeleted?: boolean;
  /**
   * The SDK client id of the user if user has access to the SDK
   * @format uuid
   */
  sdkClientId?: string | null;
  /**
   * SDK oath username (auth0 email) of the user if user has access to the SDK. For SSO users this is their email,
   * for other users this is tsdk+{sdkClientId}@treble.tech
   */
  sdkOauthUsername?: string | null;
  /**
   * Since user can have a SdkClientId and/or SdkOauthUsername but at the same time not have ProductAccess to the SDK
   * we need this boolean flag that states if the user truly has access to the SDK or not.
   */
  hasSDKAccess?: boolean;
  /**
   * The date and time when the user accepted the terms and conditions.
   * @format date-time
   */
  termsAndConditionsAcceptedAt?: string | null;
  productAccesses?: ProductAccessUserDto[] | null;
}

export interface UserWithProductInfoDto {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  organizationId?: string | null;
  auth0Id?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  trialExpiresAt?: string | null;
  featureFlags?: string[] | null;
  roles?: Role[] | null;
  isDeleted?: boolean;
  /**
   * The SDK client id of the user if user has access to the SDK
   * @format uuid
   */
  sdkClientId?: string | null;
  /**
   * SDK oath username (auth0 email) of the user if user has access to the SDK. For SSO users this is their email,
   * for other users this is tsdk+{sdkClientId}@treble.tech
   */
  sdkOauthUsername?: string | null;
  /**
   * Since user can have a SdkClientId and/or SdkOauthUsername but at the same time not have ProductAccess to the SDK
   * we need this boolean flag that states if the user truly has access to the SDK or not.
   */
  hasSDKAccess?: boolean;
  /**
   * The date and time when the user accepted the terms and conditions.
   * @format date-time
   */
  termsAndConditionsAcceptedAt?: string | null;
  /** Type of the subscription for this product, f.ex. trial and unlimited */
  billingType?: BillingType;
  /** Determines whether user has a seat in this subscription */
  isEnabled?: boolean;
  /**
   * Determines whether user will be enabled after next payment goes through
   * (in the next billing period)
   */
  shouldRenew?: boolean;
  /**
   * Determines when the TASS subscription will expire
   * @format date-time
   */
  tassSubscriptionExpiresAt?: string | null;
}

export interface WebhooksContent {
  invoice?: ChargebeeInvoice | null;
  subscription?: ChargebeeSubscription | null;
}

export interface WebhooksLineItem {
  id?: string | null;
  /** @format int64 */
  date_from?: number | null;
  /** @format int64 */
  date_to?: number | null;
  /** @format int32 */
  unit_amount?: number | null;
  /** @format int32 */
  quantity?: number | null;
  description?: string | null;
  /** @format int32 */
  amount?: number | null;
  pricing_model?: string | null;
  is_taxed?: boolean;
  /** @format int32 */
  tax_amount?: number;
  /** @format double */
  tax_rate?: number;
  subscription_id?: string | null;
  customer_id?: string | null;
  entity_type?: string | null;
  entity_id?: string | null;
  entity_description?: string | null;
  /** @format int32 */
  discount_amount?: number;
  /** @format int32 */
  item_level_discount_amount?: number;
}

export interface WebhooksRequest {
  content?: WebhooksContent | null;
  event_type?: string | null;
}
